<template>
  <section class="flex">

      <header class="container-1">
          <h3 class="abhyaas">ABHYAAS</h3>
          <h1>Yoga tailored to kids <br> of all ages.
</h1>
      
      <img src="../../assets/underline.png" alt="">
      <h3>Yoga for kids of all ages</h3>

      <h4>We've crafted our four yoga programs to ensure that the mental, <br> physical and emotional needs for kids at all developmental stages <br> are met. Have a read to see what suits your li'l yogi!</h4>
      <button>Book a class</button>
      </header>
      <div class="container-2">
      <!-- <img src="../../assets/about_program.png" alt=""> -->
      <div class="register " >
<h2>What your child will learn:</h2>
<ul >
    <li>Asanas through games and stories </li>
    <li>Meditation & Breathwork</li>
    <li>Yamas and niyamas</li>
    <li>Yogic principles</li>
    <li>Important Indian cultural stories </li>
    <li>Discipline</li>
    <li>Mental, emotional and physical control </li>
</ul>
      </div>
      </div>
  </section>

</template>

<script>
export default {

}
</script>

<style scoped>
li{
    color: white;
    font-weight: 500;
    line-height: 200%;
}
h2{
    color: white;
}

ul{
    list-style-image: url("../../assets/bullet.png");
}
.register{
    width: 500px;
min-height: 412px;
background: #791E94;
border-radius: 25px;
display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
}
 .abhyaas{
color: #791E94;
    font-weight: 450;
 }  
h3{
    color: #44526B;
}
button{
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 70px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s ease-in;
}
button:hover{
    background-color: #ca6500;
}

h1{
    color: #791E94;
    
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
}
h4{
    color: #44526B;
    font-weight: 500;
    line-height: 150%;
}
.flex{
    display: flex;
    justify-content: space-around;
    padding-top: 12rem;
    width: 90%;
    margin: auto;
}
.container-1{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
        height: 501px;
}
body{
    background: #FFFFF2;
}

@media (max-width: 1080px){
    .flex{
flex-wrap: wrap;
height: 1216px;
    }
    .container-1{
height: 525px;
    }
    ul{
            width: 209px;

    }
    h2{
        text-align: center;
        padding: 0 50px;
    }
    .register{
         width: auto;
    }
}

</style>>

